import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import './ServiceBooking.css';
import db from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

const ServiceBooking = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    budget: '',
    contactMethod: '',
    timeline: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);

    try {
      await addDoc(collection(db, 'bookings'), formData);
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        budget: '',
        contactMethod: '',
        timeline: '',
        message: ''
      });
      setSuccess(true);
      setTimeout(() => setSuccess(false), 5000);
    } catch (error) {
      console.error('Error submitting booking:', error);
      alert('❌ There was an error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="booking-page">
      <Helmet>
        <title>Book Your Service | SamSoftix IT & Software Services</title>
        <meta name="description" content="Book professional IT, software, and digital services with SamSoftix. Fill the form to request a consultation, service quote, or technical support." />
        <meta name="keywords" content="SamSoftix service booking, IT services booking, software services request, book IT consultation, Sambrial IT company, remote IT support Pakistan,Free Website Development,free development services,website in cheap price,website development for dubai bussiness" />
        <link rel="canonical" href="https://www.samsoftix.com/serviceBooking" />
      </Helmet>

      <section className="booking-hero">
        <h1>Book Your Service</h1>
        <p>Fill out the form below and we'll contact you promptly to provide the best solution.</p>
      </section>

      {success && <p className="success-message">🎉 Your service request has been submitted successfully!</p>}

      <form className="booking-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Full Name *"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email Address *"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="phone"
          placeholder="Your Phone Number *"
          value={formData.phone}
          onChange={handleChange}
          required
        />

        <select
          name="service"
          value={formData.service}
          onChange={handleChange}
          required
        >
          <option value="">-- Select Service --</option>
          <option value="Website Development">Website Development</option>
          <option value="App Development">App Development</option>
          <option value="System Modification">System Modification</option>
          <option value="Management Systems">Management Systems</option>
          <option value="Web Hosting & Domain Management">Web Hosting & Domain Management</option>
          <option value="App Deployment">App Deployment</option>
          <option value="E-commerce Solutions">E-commerce Solutions</option>
          <option value="SEO & Optimization">SEO & Optimization</option>
          <option value="UI/UX Design">UI/UX Design</option>
          <option value="API Integration">API Integration</option>
          <option value="Cloud & DevOps">Cloud & DevOps</option>
          <option value="Technical Consultation">Technical Consultation</option>
          <option value="Social Media Post Creation">Social Media Post Creation</option>
          <option value="Logo Design">Logo Design</option>
          <option value="Business Card Design">Business Card Design</option>
          <option value="Social Media Page Management">Social Media Page Management</option>
          <option value="Digital Marketing">Digital Marketing</option>
          <option value="Chatbot Training">Chatbot Training</option>
          <option value="Dataset Creation">Dataset Creation</option>
          <option value="Debugging & Testing">Debugging & Testing</option>
          <option value="Data Cleaning & Management">Data Cleaning & Management</option>
          <option value="Lab Setup (Schools & Colleges)">Lab Setup (Schools & Colleges)</option>
          <option value="Hardware Maintenance">Hardware Maintenance</option>
          <option value="Other">Other</option>
        </select>

        <input
          type="number"
          name="budget"
          placeholder="Estimated Budget (USD)"
          value={formData.budget}
          onChange={handleChange}
          min="1"
        />

        <select
          name="contactMethod"
          value={formData.contactMethod}
          onChange={handleChange}
        >
          <option value="">Preferred Contact Method</option>
          <option value="Email">Email</option>
          <option value="Phone Call">Phone Call</option>
          <option value="WhatsApp">WhatsApp</option>
          <option value="Zoom/Meet">Zoom / Google Meet</option>
        </select>

        <input
          type="text"
          name="timeline"
          placeholder="Expected Timeline (e.g. 2 weeks)"
          value={formData.timeline}
          onChange={handleChange}
        />

        <textarea
          name="message"
          placeholder="Additional details or requests"
          value={formData.message}
          onChange={handleChange}
        />

        <label className="terms-conditions">
          <input type="checkbox" required /> I agree to the <a href="/terms">Terms & Conditions</a>.
        </label>

        <button type="submit" disabled={loading}>
          {loading ? 'Submitting...' : 'Submit Request'}
        </button>
      </form>

      <section className="booking-info">
        <h2>Why Book With SamSoftix?</h2>
        <ul>
          <li>Professional IT & software solutions tailored to your business or institution.</li>
          <li>Remote support available worldwide.</li>
          <li>Secure and reliable handling of your data.</li>
          <li>Flexible service packages with transparent pricing.</li>
        </ul>
      </section>
    </div>
  );
};

export default ServiceBooking;
